import { motion } from "framer-motion";

const steps = [
  { n: "01", title: "Clean", desc: "Gently cleanse the wound with sterile water or saline and pat the surrounding skin dry." },
  { n: "02", title: "Apply", desc: "Dispense a thin, even layer of Healseeal directly over the wound and just beyond its edges." },
  { n: "03", title: "Seal", desc: "Within 12 seconds the polymer matrix sets into a flexible, breathable protective micro-seal." },
  { n: "04", title: "Heal", desc: "Healing begins within 3 minutes and the wound heals completely in about 24 hours." },
];

const timeline = [
  { value: "12", unit: "seconds", label: "Seals the wound" },
  { value: "3", unit: "minutes", label: "Healing begins" },
  { value: "24", unit: "hours", label: "Complete healing" },
];

export const HowItWorks = () => (
  <section id="how-it-works" className="py-24 md:py-32" data-testid="how-it-works-section">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <div className="flex items-baseline gap-4 mb-14 max-w-2xl">
        <span className="font-serifaccent italic text-secondary text-6xl md:text-7xl leading-none">05</span>
        <div>
          <span className="font-monotech text-xs tracking-[0.25em] uppercase text-text-muted">Chapter</span>
          <h2 className="font-heading font-extrabold text-4xl sm:text-5xl tracking-tight text-primary leading-none">
            How It Works
          </h2>
        </div>
      </div>

      {/* Timing timeline */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 lg:gap-6 mb-16">
        {timeline.map((t, i) => (
          <motion.div
            key={t.unit}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.12 }}
            className="relative bg-primary rounded-3xl p-8 overflow-hidden"
            data-testid={`timeline-${i}`}
          >
            <div className="absolute -top-6 -right-4 font-serifaccent italic text-white/10 text-8xl leading-none">
              {String(i + 1).padStart(2, "0")}
            </div>
            <div className="relative z-10">
              <div className="flex items-baseline gap-2">
                <span className="font-heading font-extrabold text-6xl text-secondary leading-none">{t.value}</span>
                <span className="font-monotech text-xs uppercase tracking-widest text-white/60">{t.unit}</span>
              </div>
              <p className="text-white font-medium mt-4">{t.label}</p>
            </div>
          </motion.div>
        ))}
      </div>

      <div className="relative">
        {steps.map((s, i) => (
          <motion.div
            key={s.n}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-8 md:py-12 border-b border-border group"
            data-testid={`how-step-${i}`}
          >
            <div className="md:col-span-3 flex items-center gap-4">
              <span className="font-heading font-extrabold text-6xl md:text-8xl text-muted group-hover:text-secondary transition-colors duration-500 leading-none">
                {s.n}
              </span>
            </div>
            <div className="md:col-span-4 flex items-center">
              <h3 className="font-heading font-bold text-3xl md:text-4xl tracking-tight text-primary">
                {s.title}
              </h3>
            </div>
            <div className="md:col-span-5 flex items-center">
              <p className="text-text-muted text-base md:text-lg leading-relaxed">{s.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
